export default {
  tiles: {
    items: {
      imageUrl: {
        'ui:widget': 'EditorUploadWidget',
      },
    },
  },
}
